<template>
  <div>
    <CCol sm="12" class="mb-3">
      <CRow class="d-flex justify-content-start">
        <p class="d-flex align-items-center mr-4 mb-0"><u>Filtrar por: </u></p>
        <!-- Filters -->
        <CRow class="d-flex flex-grow-1">
            <DropdownFilter class="mt-1 mb-1" title="Data de Inicio" :index="11" mode="date" @option-changed="startDateChanged" :defaultDate="defaultStartDate"></DropdownFilter>  
            <DropdownFilter class="mt-1 mb-1" title="Data de Fim" :index="12" mode="date" @option-changed="endDateChanged" :defaultDate="defaultEndDate"></DropdownFilter> 
            <DropdownFilter class="mt-1 mb-1 orderby-toggle" title="Ordenar por" :index="13" :options="orderOptions" @option-changed="orderChanged"></DropdownFilter> 
            <div class="d-flex justify-content-end align-items-center flex-grow-1">
                <CInputCheckbox label="Mostrar campos vazios" :checked.sync="showEmpty"></CInputCheckbox>
            </div>
        </CRow> 
      </CRow>
    </CCol>
    <!-- Graphs -->
    <CRow class="mt-5">
      <CCol>
        <!-- Tasks -->
        <p class="w-100 text-center font-weight-bold">Tarefas</p>
        <CChartBar class="chart mb-5" :datasets="tasksStats" :labels="tasksNames" :options="{ maintainAspectRatio: false }"/>
        <!-- Places -->
        <p class="w-100 text-center font-weight-bold">Lugares</p>
        <CChartBar class="chart mb-5" :datasets="placesStats" :labels="placesNames" :options="{ maintainAspectRatio: false }"/>
        <!-- People -->
        <p class="w-100 text-center font-weight-bold">Recursos humanos</p>
        <CChartBar class="chart mb-5" :datasets="peopleStats" :labels="peopleNames" :options="{ maintainAspectRatio: false }"/>
        <div v-show="loading" class="spinner-background">
          <CSpinner color="primary" grow/>
        </div>
      </CCol>
    </CRow>
  </div>
</template>
 
<script>
import { mapState, mapActions } from 'vuex';
import { CChartBar  } from '@coreui/vue-chartjs'
import DropdownFilter from '@/views/controls/DropdownFilter.vue';
import router from '@/router';
import { UTILS_HELPER } from "@/helpers/utils.js";
import InputGetComparativeData from '@/classes/InputGetComparativeData';

export default {
    components: { DropdownFilter, CChartBar },
    data () {
        return {
            searchText: '',
            startDate: UTILS_HELPER.formatDate(this.defaultStartDate), 
            endDate: UTILS_HELPER.formatDate(this.defaultEndDate),
            selectedOrderOption: null,
            loading: false,
            showEmpty: true
        }
    },
    props:
    {
        defaultStartDate:
        {
            type: Date,
            default: () => new Date(new Date().setMonth(new Date().getMonth() - 1)),
        },
        defaultEndDate:
        {
            type: Date,
            default: () => new Date(),
        },
        orderOptions:
        {
            type: Array,
            default: () => 
            [
                {"key": 0, "text": "Nome (Ascendente)"},
                {"key": 1, "text": "Nome (Descendente)"},
                {"key": 2, "text": "Horas (Ascendente)"},
                {"key": 3, "text": "Horas (Descendente)"},
                {"key": 4, "text": "Custo (Ascendente)"},
                {"key": 5, "text": "Custo (Descendente)"},
            ]
        }
    },
    computed: 
    {
        ...mapState('operations', ['comparativeData']),
        orderBy: function()
        {
            // Accepted options: Name = 0,  Hours = 1, Cost = 2,
            var result = null;

            if(this.selectedOrderOption)
            {
                var key = this.selectedOrderOption.key;
                result = Math.floor(key / 2);
            }

            return result;
        },
        orderByType: function()
        {
            // Accepted options: Asc = 0, Dsc = 1
            var result = null;

            if(this.selectedOrderOption)
            {
                var key = this.selectedOrderOption.key;
                result = (Number)(key % 2 != 0);
            }

            return result;
        },
        comparativeDataInfo: function(){
            return this.comparativeData && this.comparativeData.obj ? this.comparativeData.obj : null;
        },
        tasksNames: function()
        {
            let showEmpty = this.showEmpty;
            return this.comparativeDataInfo ? this.comparativeDataInfo.tasksStatistics.filter(stat => showEmpty || stat.hours > 0).map(stat => stat.name) : [];
        },
        tasksStats: function()
        {
            var result = 
            [
                {
                    label: 'Horas',
                    backgroundColor: 'rgb(228,102,81,0.9)',
                },
                {
                    label: 'Custos',
                    backgroundColor: 'rgb(0,216,255,0.9)',
                }
            ];

            if(this.comparativeDataInfo)
            {
                let showEmpty = this.showEmpty;

                result[0]["data"] = this.comparativeDataInfo.tasksStatistics.filter(stat => showEmpty || stat.hours > 0).map(stat => stat.hours);
                result[1]["data"] = this.comparativeDataInfo.tasksStatistics.filter(stat => showEmpty || stat.hours > 0).map(stat => stat.cost.toFixed(2));
            }

            return result;
        },
        placesNames: function()
        {
            let showEmpty = this.showEmpty;

            return this.comparativeDataInfo ? this.comparativeDataInfo.placesStatistics.filter(stat => showEmpty || stat.hours > 0).map(stat => stat.name) : [];
        },
        placesStats: function()
        {
            var result = 
            [
                {
                    label: 'Horas',
                    backgroundColor: 'rgb(228,102,81,0.9)',
                },
                {
                    label: 'Custos',
                    backgroundColor: 'rgb(0,216,255,0.9)',
                }
            ];

            if(this.comparativeDataInfo)
            {
                let showEmpty = this.showEmpty;

                result[0]["data"] = this.comparativeDataInfo.placesStatistics.filter(stat => showEmpty || stat.hours > 0).map(stat => stat.hours);
                result[1]["data"] = this.comparativeDataInfo.placesStatistics.filter(stat => showEmpty || stat.hours > 0).map(stat => stat.cost.toFixed(2));
            }

            return result;
        },
        peopleNames: function()
        {
            let showEmpty = this.showEmpty;

            return this.comparativeDataInfo ? this.comparativeDataInfo.employeesStatistics.filter(stat => showEmpty || stat.hours > 0).map(stat => stat.name) : [];
        },
        peopleStats: function()
        {
            var result = 
            [
                {
                label: 'Horas',
                backgroundColor: 'rgb(228,102,81,0.9)',
                },
                {
                label: 'Custos',
                backgroundColor: 'rgb(0,216,255,0.9)',
                }
            ];

            if(this.comparativeDataInfo)
            {
                let showEmpty = this.showEmpty;

                result[0]["data"] = this.comparativeDataInfo.employeesStatistics.filter(stat => showEmpty || stat.hours > 0).map(stat => stat.hours);
                result[1]["data"] = this.comparativeDataInfo.employeesStatistics.filter(stat => showEmpty || stat.hours > 0).map(stat => stat.cost.toFixed(2));
            }

            return result;
        },
    },
    mounted: function()
    {
        this.updateInfoRequested();
    },
    methods: {
        ...mapActions('operations', ['getComparativeData']),
        updateInfoRequested()
        {
            this.loading = true;
            var input = new InputGetComparativeData(this.startDate, this.endDate, this.orderBy, this.orderByType);

            this.getComparativeData(input);
        },
        startDateChanged(val)
        {
            this.startDate = val;
        },
        endDateChanged(val)
        {
            this.endDate = val;
        },
        orderChanged(val)
        {
            this.selectedOrderOption = val;
        }
    },
    watch:
    {
        comparativeData: function(val)
        {
            this.loading = false;
        },
        startDate(val)
        {
            if(val)
            {
                this.updateInfoRequested();
            }
        },
        endDate(val)
        {
            if(val)
            {
                this.updateInfoRequested();
            }
        },
        selectedOrderOption(val)
        {
            if(val)
            {
                this.updateInfoRequested();
            }
        },

    }
}
</script>

 
<style>

.chart
{
  height: 40vh;
  min-height: 300px;
  width: 100%;
}

.orderby-toggle
{
    min-width: 175px;
}

.spinner-background
{
  position: absolute;
  top: 0;
  bottom: 0;
  right: 0;
  left: 0;
  display: flex;
  justify-content: center;
  align-items: center;
  background-color: rgba(255,255,255,0.5);
}
</style> 